import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "7.5", cy: "15.5", r: "5.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 2-9.6 9.6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15.5 7.5 3 3L22 7l-3-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Key";
const Key = memo(themed(Icon));
export {
  Key
};
//# sourceMappingURL=key.js.map
